import { Badge } from 'components/Badge/Badge';
import './EventPreviewImageUploader.scss';

import DragAndDropImage from 'images/drag&drop.png';
import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

export const EventPreviewImageUploader = ({
  previewImageData,
  isEventPremium,
  badgeText,
  badgeIcon,
  setPreviewImageData,
}: {
  previewImageData: File | null;
  isEventPremium: boolean;
  badgeText: string;
  badgeIcon: React.ReactNode;
  setPreviewImageData: (file: File | null) => void;
}) => {
  const [acceptedFiles, setAcceptedFiles] = useState<File[]>([]);
  const onDrop = useCallback((files: File[]) => setAcceptedFiles(files), []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className='image-uploader'>
      {!previewImageData && !acceptedFiles.length ? (
        <div {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <img src={DragAndDropImage} alt='drag and drop placeholder' />
        </div>
      ) : (
        <div className='preview'>
          <img
            src={URL.createObjectURL(acceptedFiles.length ? acceptedFiles[0] : previewImageData!)}
            alt={previewImageData ? previewImageData.name : (acceptedFiles[0]?.name ?? 'preview')}
          />
          {isEventPremium && <Badge badgeText={badgeText} badgeIcon={badgeIcon} />}
        </div>
      )}
      {!previewImageData && acceptedFiles.length ? (
        <div className='actions'>
          <button
            onClick={() => {
              if (acceptedFiles.length) {
                setPreviewImageData(acceptedFiles[0]);
              }
            }}
            className='styled-button primary'
          >
            Accept
          </button>
          <button onClick={() => setAcceptedFiles([])} className='styled-button secondary'>
            Cancel
          </button>
        </div>
      ) : previewImageData ? (
        <div className='actions change-image'>
          <button
            onClick={() => {
              setPreviewImageData(null);
              setAcceptedFiles([]);
            }}
            className='styled-button secondary'
          >
            Change image
          </button>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
